<prism-tooltip [text]="deviceStateTooltip">
	<div
		id="sh-device-state-bar"
		class="sh-device-state"
		[ngClass]="{
			'sh-device-good': state === deviceStateEnum.Online,
			'sh-device-inactive': state === deviceStateEnum.Offline,
			'sh-device-ok': state === deviceStateEnum.Discovered,
			'sh-device-unknown': state === 'Unknown',
			'sh-device-bad': state === deviceStateEnum.Error
		}"
	></div>
</prism-tooltip>
